// Faixas padrão ao ligar a pontuação: o cliente ajusta em cima de algo que já
// faz sentido em vez de encarar uma tabela vazia. `stage` fica vazio de
// propósito — o backend cai para a etapa fixa do formulário quando não bate
// com nenhum slug do funil.
//
// Extraído para cá (em vez de morar só em FormScoringEditor.vue) porque a
// pontuação agora liga por DOIS caminhos — o toggle da aba Destino e o novo
// toggle da aba Campos (FormFieldsEditor.vue). Os dois precisam semear
// exatamente as mesmas faixas, senão um dos caminhos liga a pontuação e
// deixa a tabela de faixas vazia, e a feature "não faz nada" em silêncio.
export const DEFAULT_BANDS = [
  { max: 49, stage: '', label: 'lead-frio', temperature: 'cold' },
  { max: 79, stage: '', label: 'lead-morno', temperature: 'warm' },
  { max: 100, stage: '', label: 'lead-quente', temperature: 'hot' },
];

// A última faixa SEMPRE termina em 100, senão uma nota alta não cai em lugar
// nenhum. Ordenar aqui deixa a tabela sempre legível de baixo pra cima.
export const normalizeBands = list => {
  const sorted = [...list].sort((a, b) => Number(a.max) - Number(b.max));
  if (sorted.length) sorted[sorted.length - 1] = { ...sorted.at(-1), max: 100 };
  return sorted;
};

// Liga/desliga `scoring.enabled`. Ao ligar, semeia DEFAULT_BANDS quando não
// há faixa nenhuma ainda, ou apenas normaliza (ordena, força o topo em 100)
// as faixas já existentes. Ao desligar, não mexe nas faixas — só marca
// enabled como falso, para o usuário não perder a configuração ao alternar
// o switch por engano.
export const toggleScoring = (scoring, enabled) => {
  if (!enabled) return { ...scoring, enabled: false };
  const bands = scoring?.bands?.length
    ? normalizeBands(scoring.bands)
    : DEFAULT_BANDS.map(band => ({ ...band }));
  return { ...scoring, enabled: true, bands };
};
